<script setup>
defineProps({
  modelValue: {
    type: [String, Number],
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'text',
  },
  placeholder: {
    type: String,
    default: '',
  },
  error: {
    type: String,
    default: '',
  },
  prefix: {
    type: String,
    default: '',
  },
  required: {
    type: Boolean,
    default: false,
  },
  maxlength: {
    type: [Number, String],
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['update:modelValue']);
</script>

<template>
  <div class="space-y-1.5">
    <label v-if="label" class="block text-xs font-semibold text-slate-700">
      {{ label }}
      <span v-if="required" class="text-rose-500">*</span>
    </label>

    <div class="relative flex items-center">
      <div v-if="prefix" class="absolute left-3.5 text-xs font-bold text-slate-500 select-none">
        {{ prefix }}
      </div>

      <input
        :type="type"
        :value="modelValue"
        :placeholder="placeholder"
        :required="required"
        :maxlength="maxlength"
        :disabled="disabled"
        @input="$emit('update:modelValue', $event.target.value)"
        :class="[
          'w-full py-3 rounded-xl border text-sm text-slate-900 placeholder-slate-400 bg-white transition focus:outline-none focus:ring-2 disabled:bg-slate-50 disabled:text-slate-500 min-h-[44px]',
          prefix ? 'pl-12 pr-4' : 'px-4',
          error ? 'border-rose-400 focus:border-rose-500 focus:ring-rose-200' : 'border-slate-300 focus:border-indigo-500 focus:ring-indigo-100'
        ]"
      />
    </div>

    <p v-if="error" class="text-xs text-rose-600 font-medium mt-1">
      {{ error }}
    </p>
  </div>
</template>
